/**
 * ODDFISH — Blog page interactions (filter, hovers, load more, scroll reveals)
 */
(function () {
  "use strict";

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function handleScrollReveal(page) {
    if (prefersReducedMotion()) return;

    var windowBottom = window.scrollY + window.innerHeight;

    page.querySelectorAll(".animate").forEach(function (section) {
      if (section.classList.contains("scrolled")) return;

      var sectionBottom = section.offsetTop + section.offsetHeight - 50;

      if (windowBottom > sectionBottom) {
        section.classList.add("scrolled");

        section.querySelectorAll(".strike").forEach(function (el) {
          if (el.closest(".blog_block_image_link")) return;
          el.classList.add("strike-visible");
        });
      }
    });
  }

  function initScrollReveal(page) {
    if (page.dataset.oddfishBlogScrollBound) return;
    page.dataset.oddfishBlogScrollBound = "true";

    var ticking = false;

    function check() {
      handleScrollReveal(page);
      ticking = false;
    }

    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          requestAnimationFrame(check);
          ticking = true;
        }
      },
      { passive: true }
    );

    window.addEventListener("resize", check, { passive: true });
    check();
  }

  function initFilterToggle(page) {
    var filterBy = page.querySelector(".filter_by");
    var panel = page.querySelector(".form_group_wrapper");
    if (!filterBy || !panel) return;

    var panelId = panel.id || "blog-filter-panel";

    function setOpen(isOpen) {
      panel.classList.toggle("filter_active", isOpen);
      filterBy.setAttribute("aria-expanded", isOpen ? "true" : "false");
    }

    filterBy.addEventListener("click", function () {
      setOpen(!panel.classList.contains("filter_active"));
    });

    filterBy.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        setOpen(!panel.classList.contains("filter_active"));
      }
    });
  }

  function initFilterForm(page) {
    var form = page.querySelector(".filter_form");
    var grid = page.querySelector("#posts");
    var noResults = page.querySelector(".blog_no_results");
    if (!form || !grid) return;

    var cards = grid.querySelectorAll(".blog_block.item");
    var categorySelect = form.querySelector('[name="category"]');
    var monthSelect = form.querySelector('[name="month"]');

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      var category = categorySelect ? categorySelect.value : "";
      var month = monthSelect ? monthSelect.value : "";
      var visibleCount = 0;

      cards.forEach(function (card) {
        var cardCategory = card.getAttribute("data-category") || "";
        var cardMonth = card.getAttribute("data-month") || "";
        var matchCategory = !category || cardCategory === category;
        var matchMonth = !month || cardMonth === month;
        var show = matchCategory && matchMonth;

        card.classList.toggle("is-hidden", !show);
        if (show) visibleCount += 1;
      });

      if (noResults) {
        noResults.hidden = visibleCount > 0;
      }
    });
  }

  function bindStrikeHover(el) {
    if (!el || el.dataset.oddfishStrikeHoverBound) return;
    el.dataset.oddfishStrikeHoverBound = "true";

    el.addEventListener("mouseenter", function () {
      el.classList.add("strike-visible");
    });
    el.addEventListener("mouseleave", function () {
      el.classList.remove("strike-visible");
    });
    el.addEventListener("focusin", function () {
      el.classList.add("strike-visible");
    });
    el.addEventListener("focusout", function () {
      el.classList.remove("strike-visible");
    });
  }

  function initBlogBlockHovers(page) {
    page.querySelectorAll(".blog_block").forEach(function (block) {
      if (block.dataset.oddfishBlogHoverBound) return;
      block.dataset.oddfishBlogHoverBound = "true";

      var imageLink = block.querySelector(".blog_block_image_link");
      var readMore = block.querySelector(".standard_strike_btn");
      var blogStrike = block.querySelector(".blog_strike");

      if (!imageLink) return;

      imageLink.addEventListener("mouseenter", function () {
        imageLink.classList.add("is-hovered");
        if (readMore) readMore.classList.add("strike-visible");
        if (blogStrike) blogStrike.classList.add("strike-visible");
      });

      imageLink.addEventListener("mouseleave", function () {
        imageLink.classList.remove("is-hovered");
        if (readMore) readMore.classList.remove("strike-visible");
        if (blogStrike) blogStrike.classList.remove("strike-visible");
      });

      imageLink.addEventListener("focusin", function () {
        imageLink.classList.add("is-hovered");
        if (readMore) readMore.classList.add("strike-visible");
        if (blogStrike) blogStrike.classList.add("strike-visible");
      });

      imageLink.addEventListener("focusout", function () {
        imageLink.classList.remove("is-hovered");
        if (readMore) readMore.classList.remove("strike-visible");
        if (blogStrike) blogStrike.classList.remove("strike-visible");
      });
    });

    page.querySelectorAll(".standard_strike_btn").forEach(bindStrikeHover);
    page.querySelectorAll(".strike_btn").forEach(bindStrikeHover);
  }

  function initLoadMore(page) {
    var loadMore = page.querySelector(".load-more:not(.hidden)");
    var grid = page.querySelector("#posts");
    if (!loadMore || !grid || loadMore.dataset.oddfishLoadBound) return;
    if (!loadMore.getAttribute("href")) return;

    loadMore.dataset.oddfishLoadBound = "true";

    loadMore.addEventListener("click", function (e) {
      e.preventDefault();

      var nextUrl = loadMore.getAttribute("href");
      if (!nextUrl) return;

      loadMore.textContent = "Loading…";
      loadMore.setAttribute("aria-busy", "true");
      loadMore.style.pointerEvents = "none";

      fetch(nextUrl)
        .then(function (res) {
          return res.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var newPosts = doc.querySelectorAll("#posts .blog_block.item");

          if (!newPosts.length) {
            loadMore.classList.add("hidden");
            loadMore.hidden = true;
            return;
          }

          var firstNew = null;

          newPosts.forEach(function (post) {
            var clone = post.cloneNode(true);
            grid.appendChild(clone);
            if (!firstNew) firstNew = clone;
          });

          var newLoadMore = doc.querySelector(".load-more");
          if (newLoadMore && newLoadMore.getAttribute("href") && !newLoadMore.classList.contains("hidden")) {
            loadMore.setAttribute("href", newLoadMore.getAttribute("href"));
            loadMore.textContent = "Load More";
            loadMore.removeAttribute("aria-busy");
            loadMore.style.pointerEvents = "";
          } else {
            loadMore.classList.add("hidden");
            loadMore.hidden = true;
          }

          initBlogBlockHovers(page);

          if (firstNew && !prefersReducedMotion()) {
            var offset = firstNew.getBoundingClientRect().top + window.scrollY - 120;
            window.scrollTo({ top: offset, behavior: "smooth" });
          }
        })
        .catch(function () {
          loadMore.textContent = "Load More";
          loadMore.removeAttribute("aria-busy");
          loadMore.style.pointerEvents = "";
          window.location.href = nextUrl;
        });
    });
  }

  function initBlogPage(page) {
    if (!page || page.dataset.oddfishBlogBound) return;
    page.dataset.oddfishBlogBound = "true";

    initFilterToggle(page);
    initFilterForm(page);
    initBlogBlockHovers(page);
    initScrollReveal(page);
    initLoadMore(page);

    if (window.OddfishReveal) {
      window.OddfishReveal.boot(page);
    }
  }

  function init() {
    document.querySelectorAll(".blog_wrapper").forEach(initBlogPage);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var page = event.target.querySelector(".blog_wrapper");
    if (!page) return;

    delete page.dataset.oddfishBlogBound;
    delete page.dataset.oddfishBlogScrollBound;
    page.querySelectorAll("[data-oddfish-strike-hover-bound]").forEach(function (el) {
      delete el.dataset.oddfishStrikeHoverBound;
    });
    page.querySelectorAll(".blog_block").forEach(function (el) {
      delete el.dataset.oddfishBlogHoverBound;
    });
    page.querySelectorAll(".load-more").forEach(function (el) {
      delete el.dataset.oddfishLoadBound;
    });

    initBlogPage(page);
  });
})();
